import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {
  GroupContentItem,
  GroupContentItemType
} from "../../../../../../../../../chat-sdk/src/entities/groups/groupContentItem";
import {File} from "../../../../../../../../../chat-sdk/src/entities/file";
import {NativeFile} from "../../../../../../../../../chat-sdk/src/entities/nativeFile";
import {plainToInstance} from "class-transformer";

@Component({
  selector: 'app-chat-info-content',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatInfoContentComponent implements OnInit, OnChanges{
  @Input() contentType: GroupContentItemType;
  @Input() items: GroupContentItem[];
  files: (File | NativeFile | any)[] = [];
  links: string[] = [];
  constructor() {
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.convertToFile();
  }

  convertToFile() {
    if (this.contentType !== 'links') {
      this.files = plainToInstance(File, this.items.map(item => item.data.item));
    } else {
      this.links = this.items.map(item => item.data.item?.link);
    }
  }
}
